import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import GetEditFormaPago from './getEditFormaPago';
import GetEditDatosCliente from './getEditDatosCliente';
import GetViewUbication from './getViewUbication';
import GetFormasPedido from './getFormasPedido';
import GetCombo from './getCombo';
import { v4 as uuidv4 } from 'uuid';
//import { Alert } from 'reactstrap';

import '../css/getStepBuy.css';
import 'whatwg-fetch';
class getStepBuy extends Component {
  constructor(){
    super();
    this.state = {
        id_forma_pago : 0,
        forma_pago :"",
        razon_social :"CONSUMIDOR FINAL",
        ruc:"9999999999999",
        telefono:"S/N",
        direccion:"S/N",
        email:"S/N",
        id_datos_facturacion:0,
        alias:"",
        sub_modulo_modal : '',
        id_producto_combo:0,
        id_index:-1,
        precio_combo:0,
        sw_iva:0,
        direccion_entrega:'',
        referencia_entrega:''
    }
  }
  salir_prefencias =()=>{
    this.setState({
      id_producto_combo:0,
      sub_modulo_modal:'',
      id_index:-1,
      precio_combo:0,
      sw_iva:0
    })
  }
  agregarPreferencias =(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial)=>{
    this.setState({
      id_producto_combo:0,
      sub_modulo_modal:'',
      id_index:-1,
      precio_combo:0,
      sw_iva:0
    },()=>{
      this.props.props_set_preferencias(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial)
    })
  }
  agregarCantidad = (index) => {
   var items_cantidad = this.props.items_cantidad.slice();
   if(isNaN(items_cantidad[index])){
     items_cantidad[index] = 1;
   }else{
     items_cantidad[index] = Number(items_cantidad[index]) + 1;
   }
   this.props.props_set_cantidad(items_cantidad)
 }

 eliminarCantidad = (index) => {
   var items_cantidad = this.props.items_cantidad.slice();
   if(isNaN(items_cantidad[index])){
     items_cantidad[index] = "";
   }else{
     items_cantidad[index] = Number(items_cantidad[index]) - 1;
     if(items_cantidad[index]<=0){
       items_cantidad[index] = "";
     }
   }
   this.props.props_set_cantidad(items_cantidad)
 }
 get_opcion_no =()=>{

 }
 editarPreferencia =(id_producto_combo,index,precio_combo,sw_iva,title)=>{
   this.setState({
     title,
     id_producto_combo:id_producto_combo,
     sub_modulo_modal:'combo',
     id_index:index,
     precio_combo,
     sw_iva
   })
 }
 eliminarPreferencia =(index)=>{
   this.props.props_set_delete_preferencias(index)
 }
 getDescripcionPreferencia=(ditem)=>{
   let descripcion = ''
   ditem.complemento_final.forEach(cp_detalle => {
       if(cp_detalle.complemento==='Combo'){
         cp_detalle.CDetalle.forEach(cp_detalle_combo => {
            if(descripcion!=='') descripcion = descripcion + ' + '
            descripcion = descripcion + cp_detalle_combo.cant + 'x '+ cp_detalle_combo.producto
         })
       }else{
         if(descripcion!=='') descripcion = descripcion + ' + '
         if(cp_detalle.complemento==='Adicional'){
           descripcion = descripcion  + cp_detalle.cant + 'x '+  cp_detalle.producto + ' ' + cp_detalle.precio + '$'
         }else{
           descripcion = descripcion +  cp_detalle.producto
         }
       }
   })
   return(
     <React.Fragment>
       {descripcion}
     </React.Fragment>
   )
 }
 getDetallePreferencia=(index,precio_venta,component,descripcion,token_image,uuid_imagen,ext,sw_iva)=>{
   //console.log("final")
   //console.log(this.props.lista_items_adicional)
   const lista_items_adicional = this.props.lista_items_adicional.filter(
     lista_items_adicional => Number(lista_items_adicional.id_producto_combo) === Number(index)
   )
   //console.log("final2")
   //console.log(lista_items_adicional)
   return (
     <React.Fragment>
     {lista_items_adicional.map((ditem , index) => (
       <div className="cssversion_pw100 cssversion_pxh90 borderBottom" style={{"display":"flex","borderRadius": "25px 0px 25px 0px"}} >
         <div className="cssversion_pw10 cssversion_pxh90">
           <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
             1x
           </div>
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.eliminarPreferencia(index)} >
             <img style={{"width":"20px","height":"20px"}}  className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
           </div>
         </div>
         <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
           <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
            src={
              ((uuid_imagen+'').trim()==='')?
                "https://www.grupomn.net/app/img/sinfoto.png"
              :
                token_image+uuid_imagen+ext
              }/>
         </div>
         <div className="cssversion_pw55 cssversion_pxh90">
           <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
             <span className="span-global-title-producto">{component}</span>
           </div>
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             <span className="span-global-title-descripcion">
             {
               this.getDescripcionPreferencia(ditem)
             }
             </span>
           </div>
         </div>
         <div className="cssversion_pw15 cssversion_pxh90">
           <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
             <span className="span-global-title-cantidad">${(Number(ditem.precio_adicional)+Number(precio_venta)).toFixed(2)}</span>
           </div>
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.editarPreferencia(ditem.id_producto_combo,index,precio_venta,sw_iva,component)}>
           <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') }  />
           </div>
         </div>
       </div>
     ))}
     </React.Fragment>
   )
 }
/*//console.log("final")
//console.log(this.props.lista_items_adicional)
const lista_items_adicional = this.props.lista_items_adicional.filter(
  lista_items_adicional => Number(lista_items_adicional.id_producto_combo) === Number(index)
)
//console.log("final2")

return (
  <React.Fragment>
  {lista_items_adicional.map((ditem , index) => (
    <React.Fragment  key={index}>
    <div className="grid-container-items" >
      <div className="lbl_cantidad-items">
      1x</div>
      <div className="lbl_restar-items" >
      <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarPreferencia(index)}
      className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
      </div>
      <div className="lbl_precio-items">${(Number(ditem.precio_adicional)+Number(precio_venta)).toFixed(2)}</div>
      <div className="lbl_sumar-items">
      <img style={{"width":"20px","height":"20px"}} onClick={ () => this.editarPreferencia(ditem.id_producto_combo,index,precio_venta,sw_iva)}
      className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') }  />
      </div>
      <div className="lbl_item-items">{component}</div>
      <div className="lbl_descripcion-items">
      {
        this.getDescripcionPreferencia(ditem)
      }
      </div>
      <div className="lbl-imagen-items">
        <img style={{"width":"60px","height":"60px","borderRadius": "20%"}}  alt="Cargando Imagen . . ."
         src={
           ((uuid_imagen+'').trim()==='')?
             "https://www.grupomn.net/app/img/sinfoto.png"
           :
             token_image+uuid_imagen+ext
           }/>
      </div>
    </div>

    </React.Fragment>
))}
</React.Fragment>
)*/

get_ya_pedido =()=>{
    confirmAlert({
      title: 'Ya tiene Enviado un Pedido',
      message: 'Ya existe un pedido enviado al Local',
      buttons: [
        {
          label: 'Salir',
          onClick: () => this.props.get_new_pedido_loading(false,"")
        }
      ]
    })

}

 get_new_pedido =(id_forma_entrega,cuenta,valor_efectivo)=>{
     confirmAlert({
       title: 'Enviar Pedido',
       message: '¿Desea Enviar Pedido?',
       buttons: [
         {
           label: 'Sí',
           onClick: () => this.get_finalizar_pedido(id_forma_entrega,cuenta,valor_efectivo)
         },
         {
           label: 'No',
           onClick: () => this.get_opcion_no()
         }
       ]
     })

 }
 get_finalizar_pedido =(id_forma_pedido,cuenta,valor_efectivo)=>{
   //base12, base0, iva12, total, id_estado_pedido, uuid_pedido, uuid_cliente, tiempo_estimado,
   // lat, lon,
   //const lista_items = this.props.lista_items
   const url= this.props.dir_url + "webapp/getNewPedido";
   const token =  this.props.token
   const token_Client =  this.props.token_Client
   const id_sucursal = this.props.id_sucursal
   let total_final = this.props.total_final
   const id_forma_pago = this.state.id_forma_pago
   const id_datos_facturacion = this.state.id_datos_facturacion
   const lista_items_adicional = this.props.lista_items_adicional
   const lat = this.props.lat
   const lon = this.props.lon
   let detalle_pedido = []
   let costo_delivery= this.props.costo_delivery
   if(Number(id_forma_pedido===1)){
     costo_delivery = 0
     total_final = this.props.total_precio
   }
   const kilometro = Number(this.props.kilometro)
   const items = this.props.lista_items
   const direccion_entrega = this.state.direccion_entrega
   const referencia_entrega = this.state.referencia_entrega

   items.forEach (item => {
        item.Citems.forEach (ditem=> {
          if(this.props.items_cantidad[ditem.id]){
             if(Number(this.props.items_cantidad[ditem.id])>0){
              detalle_pedido=[...detalle_pedido, {
              	'cantidad': this.props.items_cantidad[ditem.id],
              	'id_producto': ditem.id,
                'observacion' : "",
                'nota' : this.props.items_observaciones[ditem.id],
                'precio_neto' : ditem.precio_venta,
                'iva': (Number(ditem.sw_iva)===1)?12:0,
                'uuid_detalle':uuidv4()
              }]
            }
          }
        })
    })
    //console.log(lista_items_adicional)
    lista_items_adicional.forEach (item => {
      const uuid_detalle = uuidv4()
      detalle_pedido=[...detalle_pedido, {
        'cantidad': '1',
        'id_producto': item.id_producto_combo,
        'observacion' : JSON.stringify(item.complemento_final),
        'precio_neto' : item.precio_inicial,
        'iva': (Number(item.sw_iva)===1)?12:0,
        'uuid_detalle': uuid_detalle
      }]
      item.complemento_final.forEach (comple => {


        if(comple.complemento==='Combo'){
          comple.CDetalle.forEach(cp_detalle_combo => {
            if(Number(cp_detalle_combo.cant)>0){
              detalle_pedido=[...detalle_pedido, {
                'cantidad': cp_detalle_combo.cant,
                'id_producto': cp_detalle_combo.id_productos,
                'precio_neto' : cp_detalle_combo.precio,
                'iva':0,
                'uuid_pertenece': uuid_detalle,
                'uuid_detalle': uuidv4()
              }]
            }
          })
        }
        if(comple.complemento==='Adicional'){
          if(Number(comple.cant)>0){
            detalle_pedido=[...detalle_pedido, {
              'cantidad': comple.cant,
              'id_producto': comple.id_productos,
              'precio_neto' : comple.precio,
              'iva': 0,
              'uuid_pertenece': uuid_detalle,
              'uuid_detalle': uuidv4()
            }]
          }
        }


      })
    })
   var obj = { accion:'nuevopedido', token, token_Client,id_sucursal,total_final,id_forma_pago,id_datos_facturacion,lat,lon,costo_delivery,detalle_pedido,id_forma_pedido,lista_items_adicional,cuenta,direccion_entrega,referencia_entrega,valor_efectivo,total_kilometros:kilometro}
   fetch(url, {
     method: 'POST',
     body: JSON.stringify(obj),
     headers:{
       'Accept':'application/json',
       'Content-Type': 'application/json'
     }
   })
   .then(res => res.json())
   .then((data) => {
     if(data[0].status==="ok"){
       this.props.get_new_pedido_loading(false,"")
     }else{
       if(data[0].status==="existe"){
         this.get_ya_pedido()

       }
     }
   })
   .catch(console.log)
   this.props.get_loading(true)
 }
 get_List_Cliente =()=>{
   const url= this.props.dir_url + "webapp/getDataClient";
   const token =  this.props.token
   const token_Client =  this.props.token_Client
   var obj = { accion:'datacliente', token, token_Client};
   fetch(url, {
     method: 'POST',
     body: JSON.stringify(obj),
     headers:{
       'Accept':'application/json',
       'Content-Type': 'application/json'
     }
   })
   .then(res => res.json())
   .then((data) => {
     if(data[0].status==="ok"){
       this.setState({
         id_forma_pago:data[0].msg[0].id_forma_pago,
         forma_pago:data[0].msg[0].forma_pago,
         id_datos_facturacion:data[0].msg[0].id_datos_facturacion,
         razon_social:data[0].msg[0].razon_social,
         ruc:data[0].msg[0].ruc,
         telefono:data[0].msg[0].telefono,
         direccion:data[0].msg[0].direccion,
         email:data[0].msg[0].correo_electronico,
         alias:data[0].msg[0].alias
       })
     }
   })
   .catch(console.log)
 }

  mostrarItems = () => {
    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_60x60
    const token_image = url_image+file_xxx+separator
    const ext="_60x60.png?alt=media"

     const items = this.props.lista_items;
     if(items.length === 0) return null;
     return (
       <React.Fragment>
         {items.map((item , index) => (
            <React.Fragment key={index}>
              {item.Citems.map((ditem , dindex) => (
                <React.Fragment key={"key_item_"+ditem.id}>
                {(this.props.items_cantidad[ditem.id])?

                  <div className="cssversion_pw100 cssversion_pxh100 borderBottom" style={{"borderRadius": "25px 0px 25px 0px"}} >
                    <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
                      <div className="cssversion_pw10 cssversion_pxh90">
                        <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                          {(this.props.items_cantidad[ditem.id])?
                            <span className="span-global-title-cantidad">
                              {this.props.items_cantidad[ditem.id]+"x"}
                            </span>
                            :
                            ""
                          }
                        </div>
                        <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.eliminarCantidad(ditem.id)} >
                          {(this.props.items_cantidad[ditem.id])?
                          <img style={{"width":"20px","height":"20px"}}  className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
                          :''}
                        </div>
                      </div>
                      <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
                        <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
                         src={
                         ((ditem.uuid_imagen+'').trim()==='')?
                           "https://www.grupomn.net/app/img/sinfoto.png"
                         :
                           token_image+ditem.uuid_imagen+ext
                         }/>
                      </div>
                      <div className="cssversion_pw55 cssversion_pxh90">
                        <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                          <span className="span-global-title-producto">{ditem.component}</span>
                        </div>
                        <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
                          <span className="span-global-title-descripcion">{ditem.descripcion} <span style={{"color":"red"}}>{this.props.items_observaciones[ditem.id]}</span></span>
                        </div>
                      </div>
                      <div className="cssversion_pw15 cssversion_pxh90">
                        <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                          <span className="span-global-title-cantidad">${ditem.precio_venta}</span>
                        </div>
                        {(Number(this.props.id_mesa)===-1)?
                          <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}}  >
                          </div>
                            :
                          <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.agregarCantidad(ditem.id,ditem.combo,ditem.precio_venta,ditem.sw_iva,ditem.component) } >
                            <img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') }  />
                          </div>
                        }
                      </div>
                    </div>
                </div>
                :''}
                {
                  this.getDetallePreferencia(ditem.id,ditem.precio_venta,ditem.component,ditem.descripcion,
                    token_image,ditem.uuid_imagen,ext,ditem.sw_iva)
                }
                </React.Fragment>
              ))}
           </React.Fragment>
         ) ) }
       </React.Fragment>
     )
   }
   /*{(this.props.items_cantidad[ditem.id])?
   <div className="grid-container-items" key={"key_item_"+ditem.id}>
     <div className="lbl_cantidad-items">
     {(this.props.items_cantidad[ditem.id])?this.props.items_cantidad[ditem.id]+"x":""}</div>
     <div className="lbl_restar-items" >
     {(this.props.items_cantidad[ditem.id])?
     <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarCantidad(ditem.id)} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
     :''}
     </div>
     <div className="lbl_precio-items">${ditem.precio_venta}</div>
     <div className="lbl_sumar-items" onClick={ () => this.agregarCantidad(ditem.id) }><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12817025351582004496-128.png') }  /></div>
     <div className="lbl_item-items">{ditem.component}</div>
     <div className="lbl_descripcion-items">{ditem.descripcion} <span style={{"color":"red"}}>{this.props.items_observaciones[ditem.id]}</span></div>
     <div className="lbl-imagen-items">
       <img style={{"width":"60px","height":"60px","borderRadius": "20%"}}  alt="Cargando Imagen . . ."
        src={
          ((ditem.uuid_imagen+'').trim()==='')?
            "https://www.grupomn.net/app/img/sinfoto.png"
          :
            token_image+ditem.uuid_imagen+ext
          }/>
     </div>
   </div>
   :<div key={"key_item_"+ditem.id}></div>}
   {
     this.getDetallePreferencia(ditem.id,ditem.precio_venta,ditem.component,ditem.descripcion,
       token_image,ditem.uuid_imagen,ext,ditem.sw_iva)
   }*/
   get_edit_formapago =()=>{
     this.setState({
       sub_modulo_modal:'editformapago'
     })
   }
   get_edit_alias =()=>{
     this.setState({
       sub_modulo_modal:'editdatosclientes'
     })
   }
   get_view_ubication =()=>{
     this.setState({
       sub_modulo_modal:'viewubicacion'
     })
   }
   get_elegirforma_pedido =()=>{
     const id_forma_pago = this.state.id_forma_pago
     const id_datos_facturacion = this.state.id_datos_facturacion
     if(Number(id_forma_pago)>0&&Number(id_datos_facturacion)===0){
       confirmAlert({
         title: 'Pago en Tarjeta de Crédito',
         message: 'Favor Ingresar sus datos para la Factura',
         buttons: [
           {
             label: 'OK',
             onClick: () => this.get_opcion_no()
           }
         ]
       })
       return null
     }

     if(Number(this.props.id_mesa)===0&&!this.props.sucursal){
       const direccion_entrega = this.state.direccion_entrega.trim()
       const referencia_entrega = this.state.referencia_entrega.trim()
       if(direccion_entrega===''){
         this.direccionentregaInput.focus();
         return null
       }
       if(referencia_entrega===''){
         this.referenciaentregaInput.focus();
         return null
       }
     }
     this.setState({
       sub_modulo_modal:'formapedido'
     })
   }

   get_go_to_sub =(sub_modulo_modal)=>{
     this.setState({
       sub_modulo_modal
     },()=>{
       this.get_List_Cliente()
     })
   }
   inputChangedHandler1 = (event)=>{
     this.setState({
       direccion_entrega :event.target.value
     })
   }
   KinputChangedHandlerText1=(event)=>{
       if (event.keyCode === 13) {
          //console.log("Enter key pressed!!!!!");
          document.getElementById('button_continuar').focus();
       }
   }
   inputChangedHandler2 = (event)=>{
     this.setState({
       referencia_entrega :event.target.value
     })
   }
  render() {

    const sub_modulo_modal = this.state.sub_modulo_modal
    let dir_sub_modulo_modal
    if(sub_modulo_modal==='editformapago'){
        dir_sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetEditFormaPago token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(sub_modulo_modal==='editdatosclientes'){
        dir_sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetEditDatosCliente  token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(sub_modulo_modal==='viewubicacion'){
        dir_sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetViewUbication lat={this.props.lat} lon={this.props.lon} get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(sub_modulo_modal==='formapedido'){
        dir_sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetFormasPedido sucursal={this.props.sucursal}   id_forma_pago={this.state.id_forma_pago} total_precio={this.props.total_precio} total_final={this.props.total_final} id_mesa={this.props.id_mesa} lat={this.props.lat} lon={this.props.lon} get_new_pedido={this.get_new_pedido} get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(sub_modulo_modal==='combo'){
      dir_sub_modulo_modal = <div id="loader_msg_sucursal" className="loader_msg_sucursal is-active" data-text="">
                        <GetCombo sw_iva={this.state.sw_iva} precio_combo={this.state.precio_combo} lista_items_adicional={this.props.lista_items_adicional} id_index={this.state.id_index} agregarPreferencias={this.agregarPreferencias} salir_prefencias={this.salir_prefencias} id_producto_combo={this.state.id_producto_combo} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal}   props_set_data_items={this.props_set_data_items} props_set_cantidad={this.props_set_cantidad} lista_items={this.state.lista_items}  items_cantidad={this.state.items_cantidad} total_items={this.state.total_items} total_precio={this.state.total_precio} token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to} id_sucursal={this.state.id_sucursal} title={this.state.title} costo_delivery={this.state.costo_delivery} puntuacion={this.state.puntuacion} tiempo={this.state.tiempo} />
                        </div>
    }

    //console.log(this.props.sucursal)
    const total_items = this.props.total_items
    return (
      <React.Fragment>
      <div className="cssversion_menu cssversion_colorprimario">
        <div className="cssversion_pw100 cssversion_ph85 cssversion_colorblanco cssversion_contentCenter" >
          <div className="cssversion_pw100 cssversion_ph100 cssversion_colorblanco" style={{"overflowY":"auto"}}>
            {this.mostrarItems()}
            {(Number(this.props.id_mesa)===0&&!this.props.sucursal)?
              <React.Fragment>
              <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}}>
                <div className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">DIRECCIÓN DE ENTREGA</div>
                <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  /></div>
              </div>
              <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} onClick={ () => this.get_view_ubication()}>
                <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"30px","height":"30px"}} alt="Cargando Imagen . . ." src={ require('../image/fecha_derecha.gif') }  /></div>
                <div className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">{this.props.name}</div>
              </div>
              <div className="cssversion_pw100 cssversion_pxh40" style={{"display":"flex"}}>
                <div className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter"><input onKeyUp={(event)=>this.KinputChangedHandlerText1(event)} ref={(input) => { this.direccionentregaInput = input; }}  value={this.state.direccion_entrega} onChange={(event)=>this.inputChangedHandler1(event)} className="input-global cssversion_pw90 red-input" placeholder="Dirección de Entrega" /></div>
                <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  /></div>
              </div>
              <div className="cssversion_pw100 cssversion_pxh40" style={{"display":"flex"}}>
                <div className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter"><input onKeyUp={(event)=>this.KinputChangedHandlerText1(event)} ref={(input) => { this.referenciaentregaInput = input; }}  value={this.state.referencia_entrega} onChange={(event)=>this.inputChangedHandler2(event)} className="input-global cssversion_pw90 red-input" placeholder="Referencia de Entrega" /></div>
                <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  /></div>
              </div>
              </React.Fragment>
            :''}
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}}>
              <div className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">FORMA DE PAGO</div>
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} onClick={ () => this.get_edit_formapago()}>
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"30px","height":"30px"}} alt="Cargando Imagen . . ." src={ require('../image/fecha_derecha.gif') }  /></div>
              <div className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">{this.state.forma_pago}

              



              </div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}}>
              <div className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">DATOS DEL COMPROBANTE</div>
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4798580041582004495-128.png') }  /></div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} onClick={ () => this.get_edit_alias()}>
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"30px","height":"30px"}} alt="Cargando Imagen . . ." src={ require('../image/fecha_derecha.gif') }  /></div>
              <div className="cssversion_pw80 cssversion_ph100 cssversion_contentCenter">{this.state.alias}</div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  /></div>
              <div className="cssversion_pw80 cssversion_ph100 ">{this.state.razon_social}</div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  /></div>
              <div className="cssversion_pw80 cssversion_ph100 ">{this.state.ruc}</div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9180212681582004495-128.png') }  /></div>
              <div className="cssversion_pw80 cssversion_ph100 ">{this.state.telefono}</div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') }  /></div>
              <div className="cssversion_pw80 cssversion_ph100 ">{this.state.direccion}</div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw20 cssversion_ph100 cssversion_contentCenter"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') }  /></div>
              <div className="cssversion_pw80 cssversion_ph100 ">{this.state.email}</div>
            </div>

            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw70 cssversion_ph100 " style={{"padding":"10px"}}>Subtotal Productos</div>
              <div className="cssversion_pw30 cssversion_ph100 cssversion_contentRight">${Number(this.props.total_precio).toFixed(2)}</div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw70 cssversion_ph100 " style={{"padding":"10px"}}>Kilómetros</div>
              <div className="cssversion_pw30 cssversion_ph100 cssversion_contentRight">KM {Number(this.props.kilometro).toFixed(2)}</div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw70 cssversion_ph100 " style={{"padding":"10px"}}>{(Number(this.props.id_mesa)>0)?
              "Servicio 10%"
              :
              "Transporte"
              }</div>
              <div className="cssversion_pw30 cssversion_ph100 cssversion_contentRight">${Number(this.props.costo_delivery).toFixed(2)}</div>
            </div>
            <div className="cssversion_pw100 cssversion_pxh35" style={{"display":"flex"}} >
              <div className="cssversion_pw70 cssversion_ph100 " style={{"padding":"10px","fontSize":"18pt"}}><b>Total Comprobante</b></div>
              <div className="cssversion_pw30 cssversion_ph100 cssversion_contentRight" style={{"fontSize":"18pt"}} ><b>${Number(this.props.total_final).toFixed(2)}</b></div>
            </div>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_ph15 cssversion_colorblanco cssversion_contentCenter" style={{"display":"flex"}}>
          <button style={{"height":"80%","width":"48%","padding":"2px"}} className="button-global" onClick={ () => this.props.get_go_to("lista_items")}>Regresar</button>
          {(Number(total_items)>0)?
          <button id="button_continuar" style={{"height":"80%","width":"48%","padding":"2px"}} className="button-global" onClick={ () => this.get_elegirforma_pedido()}>COMPRAR</button>
          :
          <button id="button_continuar" style={{"height":"80%","width":"48%","padding":"2px"}} className="button-global-disabled"></button>
          }
        </div>
        {dir_sub_modulo_modal}
      </div>
      </React.Fragment>
    );
  }
  componentDidMount (){
    this.get_List_Cliente();
  }
}
export default getStepBuy;

/*<div className="grid-container-global_items_final">
  <div className="container-items-global_final" >

    <div className="grid-container_buy">
      <div className="lbl_title_final">FORMA DE PAGO</div>
      <div className="lbl_icon_final"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  /></div>
    </div>
    <div className="grid-container_buy_detalle" onClick={ () => this.get_edit_formapago()}>
      <div className="lbl_title_final_detalle"><img style={{"width":"30px","height":"30px"}}  alt="Cargando Imagen . . ." src={ require('../image/fecha_derecha.gif') }  /></div>
      <div className="lbl_icon_final_detalle">{this.state.forma_pago}</div>
    </div>
    <div className="grid-container_buy">
      <div className="lbl_title_final">DATOS DEL COMPROBANTE</div>
      <div className="lbl_icon_final"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/4798580041582004495-128.png') }  /></div>
    </div>
    <div className="grid-container_buy_detalle"  onClick={ () => this.get_edit_alias()}>
      <div className="lbl_title_final_detalle"><img style={{"width":"30px","height":"30px"}} alt="Cargando Imagen . . ." src={ require('../image/fecha_derecha.gif') }  /></div>
      <div className="lbl_icon_final_detalle">{this.state.alias}</div>
    </div>
    <div className="grid-container_buy_detalle">
      <div className="lbl_title_final_detalle"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  /></div>
      <div className="lbl_icon_final_detalle">{this.state.razon_social}</div>
    </div>
    <div className="grid-container_buy_detalle">
      <div className="lbl_title_final_detalle"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  /></div>
      <div className="lbl_icon_final_detalle">{this.state.ruc}</div>
    </div>
    <div className="grid-container_buy_detalle">
      <div className="lbl_title_final_detalle"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9180212681582004495-128.png') }  /></div>
      <div className="lbl_icon_final_detalle">{this.state.telefono}</div>
    </div>
    <div className="grid-container_buy_detalle">
      <div className="lbl_title_final_detalle"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') }  /></div>
      <div className="lbl_icon_final_detalle">{this.state.direccion}</div>
    </div>
    <div className="grid-container_buy_detalle">
      <div className="lbl_title_final_detalle"><img style={{"width":"20px","height":"20px"}} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16467180181582004498-128.png') }  /></div>
      <div className="lbl_icon_final_detalle">{this.state.email}</div>
    </div>
    <div className="grid-container_buy_comprobante">
      <div className="lbl_title_final_comprobante">Subtotal Productos</div>
      <div className="lbl_icon_final_comprobante">${Number(this.props.total_precio).toFixed(2)}</div>
    </div>
    <div className="grid-container_buy_comprobante">
      <div className="lbl_title_final_comprobante">
      {(Number(this.props.id_mesa)>0)?
      "Servicio 10%"
      :
      "Transporte"
      }
      </div>
      <div className="lbl_icon_final_comprobante">${Number(this.props.costo_delivery).toFixed(2)}</div>
    </div>
    <div className="grid-container_buy_comprobante">
      <div className="lbl_title_final_comprobante">Total Comprobante</div>
      <div className="lbl_icon_final_comprobante">${Number(this.props.total_final).toFixed(2)}</div>
    </div>
    <div className="title_buy" style={{"width":"100%","height":"130px"}} >
    </div>
  </div>

  {dir_sub_modulo_modal}
</div>*/
